export default {
  name: 'Inactive'
};